import Vue from 'vue';
import Calendar from '../module/calendar/Calendar';

import '../../../scss/app/event_calendar.scss';

new Vue({
  el: '.js-calendar',
  components: {
    Calendar,
  },
});
